module.exports = __webpack_public_path__ + "img/client-2--small.png?1e794fa32aa023852fc7e56d41749220";